export enum TitleImageOverflowMode {
  Hidden = 'hidden',
  Visible = 'visible'
}
